
const IntAllDirective = {
  mounted(el, binding) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (!input) return

    let locking = false

    input.addEventListener('compositionstart', () => {
      locking = true // 解决中文输入双向绑定失效
    })

    input.addEventListener('compositionend', () => {
      locking = false // 解决中文输入双向绑定失效
      trigger(input, 'input')
    })

    const handleInput = (e) => {
      if (locking) return
      
      if (input.value.length === 1) {
        input.value = input.value.replace(/[^0-9]/g, '')
      } else {
        input.value = input.value.replace(/[^\d]/g, '')
      }
      trigger(input, 'input')
    }

    input.addEventListener('keyup', handleInput)
    input.addEventListener('blur', handleInput)

    // 保存事件处理函数引用以便卸载时移除
    el._intAllHandlers = {
      handleInput
    }
  },
  unmounted(el) {
    const input = el.tagName === 'INPUT' ? el : el.querySelector('input')
    if (!input || !el._intAllHandlers) return

    const { handleInput } = el._intAllHandlers
    input.removeEventListener('keyup', handleInput)
    input.removeEventListener('blur', handleInput)
  }
}

const trigger = (el, type) => {
  const e = new Event(type, { bubbles: true })
  el.dispatchEvent(e)
}

export default IntAllDirective